<!-- Breadcrumb -->

<div class="page-breadcrumb">
  <div fxLayout="column" fxLayoutAlign="start start" >
    <div class="breadcrumb">
      <ul class="list-style-none d-flex align-items-center">
        <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
          <li class="breadcrumb-item" [routerLink]="url.url">
            <a [routerLink]="url.url" *ngIf="!last">
              {{url.title}}
            </a>

            <a *ngIf="last">
              {{url.title}}
            </a>

          </li>
        </ng-template>
      </ul>
    </div>
    <div>
      <!--<h2 class="page-title text-white">{{pageInfo?.title}}</h2>-->
    </div>
  </div>
</div>
